<template>
  <div class="mainWrapper">
    <div class="sourceMain">
      <b-row class="sourceMainSections">
        <b-col sm="2" class="sectionsFilters">
          <b-col class="filters">
            <p>Filtros</p>
          </b-col>
          <b-col class="section1">
            <b-row>
              <b-col sm="12">
                <span class="filtersTitle">Temática</span>
              </b-col>
              <b-col>
                <v-select
                  style="background-color: white"
                  v-model="selectedThemeViewFilter"
                  :options="optionsThemesFilter"
                  label="item"
                  :reduce="(item) => item.code"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <span class="filtersTitle">Palavra</span>
              </b-col>
              <b-col>
                <b-form-input v-model="stringOfThemesFilter"></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <span class="filtersTitle">Palavra Proibida</span>
              </b-col>
              <b-col>
                <b-form-input v-model="stringOfProhibitedThemesFilter"></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
        <b-col sm="10" class="sectionOperation" style="margin-top: 20px">
          <h5
            style="font-weight: bold; text-align: left"
            v-b-popover.hover.left="
              'Adicione aqui as temáticas que ainda não foram caracterizadas no motor de scrapping'
            "
          >
            Caracterização da Temática
          </h5>
          <b-row>
            <b-col sm="3">
              <v-select
                v-model="selectedThemeView"
                :options="optionsThemesView"
                label="item"
                placeholder="selecionar temática"
                :reduce="(item) => item.code"
              >
                <span slot="no-options">Não foram obtidos resultados</span>
              </v-select>
            </b-col>
            <b-col sm="3">
              <b-form-input
                v-model="stringOfThemes"
                placeholder="Adicionar Palavras"
              ></b-form-input>
            </b-col>
            <b-col sm="3">
              <b-form-input
                v-model="stringOfProhibitedThemes"
                placeholder="Adicionar Palavras Proibidas"
              ></b-form-input>
            </b-col>
            <b-col sm="2">
              <button
                style="background-color: rgb(66, 139, 172); color: white"
                @click="createNewTheme(selectedThemeView, stringOfThemes, stringOfProhibitedThemes)"
              >
                Adicionar
              </button>
            </b-col>
          </b-row>
          <hr
            style="border-color: black; margin-top: 20px; margin-bottom: 20px"
          />
          <b-col style="margin-top: 10px; padding: 0px">
            <h5 style="font-weight: bold; text-align: left; margin-top: 20px">
              Listagem Temática-Keywords
            </h5>
            <b-table
              hover
              :items="filteredData"
              :per-page="15"
              :currentPage="currentPage"
              @row-dblclicked="toggleDetails"
              :fields="fieldsThemeWords"
              small
              fixed
              caption-top
            >
              <template v-slot:table-caption
                ><span style="font-weight: bold; color: black">Nota:</span> Para
                editar a caracterização de um Temática-Keywords, faça duplo clique
                sobre a linha da temática pretendida</template
              >
              <template slot="row-details" slot-scope="row">
                <b-row class="rowDetails">
                  <b-col sm="2" style="text-align: center">
                    <b-col>
                      <span class="ThemeWord">Temática:</span>
                    </b-col>
                    <b-col>
                      {{ row.item.wordName }}
                    </b-col>
                  </b-col>
                  <b-col sm="4">
                    <b-col>
                      <span class="ThemeWord">Palavras:</span>
                    </b-col>
                    <b-col>
                      <b-form-input v-model="row.item.c_u_Words"></b-form-input>
                    </b-col>
                  </b-col>
                  <b-col sm="4">
                    <b-col>
                      <span class="ThemeWord">Palavras Proibida:</span>
                    </b-col>
                    <b-col>
                      <b-form-input v-model="row.item.c_u_ProhibitedWords"></b-form-input>
                    </b-col>
                  </b-col>
                  <b-col sm="2">
                    <b-col>
                      <button
                        style="
                          background-color: rgb(66, 139, 172);
                          color: white;
                        "
                        @click="editThemWords(row.item)"
                      >
                        Guardar
                      </button>
                      <button
                        style="color: rgb(66, 139, 172); margin-top: 5px"
                        @click="row.item._showDetails = false"
                      >
                        Cancelar
                      </button>
                    </b-col>
                  </b-col>
                </b-row>
              </template>
            </b-table>
          </b-col>
          <div class="mt-3">
            <b-pagination
              :total-rows="totalItems"
              :per-page="15"
              align="center"
              v-model="currentPage"
            ></b-pagination>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import router from "../router/index";
import Chart from "chart.js";
import everyHourChartData from "./chart-data.js";
import operationLogsChart from "./chart-operation-logs.js";
import vSelect from "vue-select";
import Vue from "vue";

export default {
  name: "ThemeWords",

  data() {
    return {
      itemsThemeWords: [],
      endpoint: "ThemeWords",
      endpointVThemes: "VThemes",
      VThemes: [],
      currentPage: 1,
      totalItems: 0,
      optionsThemesView: [],
      optionsThemesFilter: [],
      stringOfThemesFilter: "",
      selectedThemeViewFilter: [],
      selectedThemeView: [],
      stringOfThemes: "",
      stringOfProhibitedThemes: "",
      stringOfProhibitedThemesFilter: "",
      filteredData: [],
      lo: _,
      fieldsThemeWords: [
        {
          key: "wordName",
          label: "Temática",
          formatter: (value, key, item) => {
            return value;
          },
        },
        {
          key: "c_u_Words",
          label: "Palavras",
        },
        {
          key: "c_u_ProhibitedWords",
          label: "Palavras Proibida",
        },
      ],
    };
  },

  components: {
    vSelect,
  },

  watch: {
    selectedThemeViewFilter(to, from) {
      if (to != null) {
        this.filteredData = _.filter(this.itemsThemeWords, (id) => {
          return id.c_u_ThemeId == to;
        });
      } else {
        this.filteredData = _.orderBy(
          this.itemsThemeWords,
          ["wordName"],
          ["asc"]
        );
      }
      this.totalItems = this.filteredData.length;
    },
    stringOfThemesFilter(to, from) {
      if (to != "") {
        this.filteredData = _.filter(this.itemsThemeWords, (theme) => {
          return theme.c_u_Words != ""
            ? theme.c_u_Words.toLowerCase().indexOf(to.toLowerCase()) > -1
            : false;
        });
      } else {
        this.filteredData = _.orderBy(
          this.itemsThemeWords,
          ["wordName"],
          ["asc"]
        );
      }
      this.totalItems = this.filteredData.length;
    },
    stringOfProhibitedThemesFilter(to, from) {
      if (to != "") {
        this.filteredData = _.filter(this.itemsThemeWords, (theme) => {
          return theme.c_u_ProhibitedWords != ""
            ? theme.c_u_ProhibitedWords.toLowerCase().indexOf(to.toLowerCase()) > -1
            : false;
        });
      } else {
        this.filteredData = _.orderBy(
          this.itemsThemeWords,
          ["wordName"],
          ["asc"]
        );
      }
      this.totalItems = this.filteredData.length;
    },
  },

  methods: {
    async autoReloadData() {},
    async showData() {
      this.$api.data.endpoint = this.endpoint;
      this.itemsThemeWords = await this.$api.data.find();
      this.totalItems = this.itemsThemeWords.length;
      this.$api.data.endpoint = this.endpointVThemes;
      this.VThemes = await this.$api.data.find();
      let newArrayOfThemes = this.VThemes;
      //For to themes in filter
      this.optionsThemesFilter = [];
      for (let index = 0; index < this.VThemes.length; index++) {
        Vue.set(this.optionsThemesFilter, index, {
          item: this.VThemes[index].wordName,
          code: this.VThemes[index].id,
        });
      }

      for (let index = 0; index < this.itemsThemeWords.length; index++) {
        let id = this.itemsThemeWords[index].c_u_ThemeId;
        let thm = _.find(this.VThemes, function (o) {
          return o.id == id;
        });
        this.itemsThemeWords[index] = {
          c_id: this.itemsThemeWords[index].c_id,
          c_u_ThemeId: this.itemsThemeWords[index].c_u_ThemeId,
          c_u_Words: this.itemsThemeWords[index].c_u_Words,
          c_u_ProhibitedWords: this.itemsThemeWords[index].c_u_ProhibitedWords,
          wordName: thm == undefined ? thm : thm.wordName,
        };
      }
      _.remove(this.itemsThemeWords, function (n) {
        return n.wordName == undefined;
      });
      this.filteredData = this.itemsThemeWords;
      // for to have items in dropdown of create theme
      for (let index = 0; index < this.itemsThemeWords.length; index++) {
        let id = this.itemsThemeWords[index].c_u_ThemeId;
        _.remove(newArrayOfThemes, function (n) {
          return n.id == id;
        });
      }
      if (newArrayOfThemes.length > 0) {
        for (let index = 0; index < newArrayOfThemes.length; index++) {
          Vue.set(this.optionsThemesView, index, {
            item: newArrayOfThemes[index].wordName,
            code: newArrayOfThemes[index].id,
          });
        }
      }

      this.filteredData = _.orderBy(this.filteredData, ["wordName"], ["asc"]);
    },
    toggleDetails(data) {
      this.$set(data, "_showDetails", data._showDetails ? false : true);
    },
    async editThemWords(item) {
      let editedTheme = {
        c_id: item.c_id,
        c_u_ThemeId: item.c_u_ThemeId,
        c_u_Words: item.c_u_Words,
        c_u_ProhibitedWords: item.c_u_ProhibitedWords,
      };
      this.$api.data.endpoint = this.endpoint;
      await this.$api.data.updatedById(item.c_id, editedTheme);
      item._showDetails = false;
    },
    async createNewTheme(theme, string, stringProhibited) {
      if (typeof theme != "object") {
        let newObjectTheme = { c_u_ThemeId: theme, c_u_Words: string , c_u_ProhibitedWords: stringProhibited };
        this.$api.data.endpoint = this.endpoint;
        let result = await this.$api.data.create2(newObjectTheme);
        if (result == "Theme Word criada com sucesso") {
          this.$bvToast.toast("Temática adicionada com sucesso", {
            autoHideDelay: 4000,
            variant: "success",
          });
          //this.showData();//does not refresh the select
          setTimeout(function () {
            window.location.reload();
          }, 1000);
        }
      } else {
        this.$bvToast.toast("Necessario preencher campos!", {
          autoHideDelay: 4000,
          variant: "danger",
        });
      }
    },
  },
  computed: {
    ...mapGetters({}),
  },

  async mounted() {
    this.showData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mainWrapper {
  /*
  height: calc(100vh - 90px);
  overflow: hidden; */
  overflow: scroll;
}

.captionTable {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: white;
  text-align: center;
  caption-side: bottom;
  background-color: #007bff;
  margin-top: 5px;
  margin-bottom: 0px;
}
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.sourceMain {
  overflow: hidden;
  /* height: 100vh; */
  height: 100%;
}

.sourceMainSections {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  height: 100%;
}
.rowDetails {
  background-color: rgb(236, 236, 236);
}

.sectionsFilters {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 111px);
}

.sectionOperation {
  display: block;
  max-height: 100%;
  height: 100%;
}

.section1 {
  margin-top: 10px;
  background-color: rgb(242, 242, 242);
}

.filters {
  background-color: rgb(66, 139, 172);
  color: white;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  height: 50px;
  max-height: 50px;
}

.filtersTitle {
  float: left;
  color: rgb(66, 139, 172);
  font-weight: bold;
  font-size: 12px;
  text-align: start;
}

.filtersSelect {
  background-color: white;
}
.checkBox {
  margin-top: 5px;
}

.filtersCheckBox {
  color: rgb(66, 139, 172);
  font-weight: bold;
  font-size: 12px;
}

.filterButton {
  margin-top: 20px;
}
.btnFilter {
  background-color: rgb(66, 139, 172);
  color: white;
  font-weight: bold;
}

.btnFilterClear {
  background-color: white;
  color: black;
  font-weight: bold;
}
.section1Title {
  background-color: rgb(66, 139, 172);
  color: white;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  height: 50px;
  margin-top: 10px;
}

.createDiv {
  text-align: right;
}

.createBtn {
  border-radius: 20px;
  background-color: rgb(231, 242, 245);
  color: rgb(66, 139, 172);
  padding: 0.275rem 0.55rem;
}

.ThemeWord {
  color: rgb(66, 139, 172);
  font-weight: bold;
}

.section2 {
  background-color: rgb(242, 242, 242);
  overflow-y: scroll;
  height: 100%;
}

.section2Source {
  border: 2px solid rgb(242, 242, 242);
  margin: 5px;
}

.section2Source:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
}

.section2Log {
  background-color: rgb(202, 229, 205);
  color: black;
  font-weight: bold;
  font-size: 12px;
  text-align: left;
  margin: 5px;
}
.section2LogText {
  word-wrap: break-word;
}

.section2Error {
  background-color: rgb(231, 179, 184);
  color: black;
  font-weight: bold;
  font-size: 12px;
  text-align: left;
  margin: 5px;
}

.section3Reference {
  background-color: rgb(24, 65, 77);
  color: white;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  height: 50px;
  margin-top: 10px;
}
.section3Title {
  background-color: rgb(66, 139, 172);
  color: white;
  font-weight: bold;
  text-align: left;
  border-radius: 10px;
  padding: 10px;
  height: 50px;
  margin-top: 10px;
}
.labelLog {
  background-color: rgb(66, 139, 172);
  color: white;
  font-weight: bold;
  text-align: left;
  border-radius: 10px;
  margin-top: 10px;
}

.referenceName {
  background-color: rgb(242, 242, 242);
  text-align: left;
  border-radius: 10px;
  margin-top: 10px;
}

.editXML button {
  background-color: rgb(66, 139, 172);
  color: white;
  margin-top: 10px;
  font-weight: bold;
}

.createXML button {
  background-color: rgb(66, 139, 172);
  color: white;
  margin-top: 10px;
  font-weight: bold;
}

.section3Footer button {
  background-color: rgb(77, 150, 132);
}
</style>



// WEBPACK FOOTER //
// src/components/ThemeWords.vue